// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3ewvX","savePackageButton":"ClientWallet_savePackageButton__2K3i3"};